import React from 'react';
import { optimizedImage } from '../imageUrl';
import '../style/card.css';

// Année lisible à partir d'une date ISO ou d'une année brute.
function getYear(releaseDate) {
  if (!releaseDate) return '';
  return releaseDate.toString().slice(0, 4);
}

function Card({ film, onClick }) {
  const year = getYear(film.releaseDate);
  const poster = film.posterURL
    ? { backgroundImage: `url(${optimizedImage(film.posterURL, 600)})` }
    : undefined;

  // L'affiche contient déjà le titre : on n'affiche que l'année, la durée,
  // et le nombre d'épisodes pour les séries.
  const metaParts = [year, film.duration].filter(Boolean);
  if (film.isSeries) {
    const count = (film.episodes || []).length;
    if (count) metaParts.push(`${count} épisode${count > 1 ? 's' : ''}`);
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <figure
      className="bb-card-film"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-label={`Ouvrir ${film.title}`}
    >
      <div className="bb-card-film__poster" style={poster} />
      {metaParts.length > 0 && (
        <>
          <div className="bb-card-film__scrim" />
          <figcaption className="bb-card-film__cap">
            <span className="bb-card-film__meta bb-meta">
              {metaParts.join('  ·  ')}
            </span>
          </figcaption>
        </>
      )}
    </figure>
  );
}

export default Card;
